import { RawColumn, Section, SectionType } from '../models';

/**
 * Discriminator function for sections of `details` type to find, filter
 * @param section
 */
export const isDetailSection = <T extends RawColumn>(section: Pick<Section<T>, 'type'>): boolean =>
  section.type === SectionType.Details;
